import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
} from "@mui/material";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "stores";
import store from "stores/interfaces";
import styled from "styled-components";
import { ReactComponent as SoundMasterLogo } from "../../containers/PlanSelect/SoundMasterLogo.svg";
import { ReactComponent as WelcomeImage } from "./welcome.svg";
import ProAnime from "./pro-anime.png";

const JoinedSoundMasterDialog = () => {
  const [t] = useTranslation();
  const dispatch = useAppDispatch();
  const open = useAppSelector((state) =>
    store.getAppState(state, "openJoinedSoundMaster")
  );
  const onClose = useCallback(() => {
    dispatch(
      store.appStateMutate((state) => {
        state.openJoinedSoundMaster = false;
      })
    );
  }, [dispatch]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogContent>
        <WrapAnimation>
          <img src={ProAnime} />
        </WrapAnimation>
        <WrapWelcome>
          <WelcomeImage role="img" aria-label={t("CCFOLIA PRO にようこそ")} />
        </WrapWelcome>
        <WrapWelcomeSecondary>
          <Typography sx={{ pr: 1 }}>with</Typography>
          <SoundMasterLogo role="img" aria-label="SOUND MASTER" width="150" />
        </WrapWelcomeSecondary>
        <DialogContentText component="div">
          <Typography paragraph>{t("おめでとうございます！")}</Typography>
          <Typography paragraph>
            {t(
              "今日からあなたはココフォリアのプロ、そしてサウンドマスターです。追加された機能でセッションをさらに盛り上げましょう。"
            )}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" fullWidth>
          {t("閉じる")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const WrapAnimation = styled.div`
  display: flex;
  justify-content: center;
  margin: 16px 0 32px 0;
`;

const WrapWelcome = styled.div`
  display: flex;
  justify-content: center;
  margin: 16px 0 0 0;
`;

const WrapWelcomeSecondary = styled.div`
  display: flex;
  justify-content: center;
  margin: 8px 0 32px 0;
`;

export default memo(JoinedSoundMasterDialog);
